import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brev-app/brev-app/packages/frontend/src/components/LoadingPage.tsx");
